module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bolditalic-webfont.17db293d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bolditalic-webfont.woff
// module id = 386
// module chunks = 3